import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines } from "./motion";

const PageHero = ({ eyebrow, title, sub, image, crumbs = [] }) => (
  <header className="relative flex min-h-[72svh] items-end overflow-hidden">
    <motion.img
      src={image}
      alt=""
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/35" />
    <div className="container-ek relative pb-16 pt-40 md:pb-20">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="eyebrow flex items-center gap-3"
      >
        <span className="inline-block h-px w-10 bg-gold" />
        {eyebrow}
      </motion.p>
      <h1 className="mt-5 font-serif text-5xl font-medium leading-[1.02] text-white sm:text-6xl lg:text-7xl">
        <MaskedLines
          animate
          delay={0.25}
          lines={Array.isArray(title) ? title : [title]}
        />
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg"
        >
          {sub}
        </motion.p>
      )}
      {crumbs.length > 0 && (
        <motion.nav
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-8 flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-mist"
          aria-label="Breadcrumb"
        >
          <Link to="/" className="transition-colors hover:text-gold">
            Home
          </Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-3 w-3 text-gold/60" />
              <span className={i === crumbs.length - 1 ? "text-gold" : ""}>{c}</span>
            </span>
          ))}
        </motion.nav>
      )}
    </div>
  </header>
);

export default PageHero;
